export const DENY = 3;
export const ACCEPT = 2;
export const PENDING = 1;
